import { render } from "./AddressInfoSection.vue?vue&type=template&id=908acf2e&scoped=true"
import script from "./AddressInfoSection.vue?vue&type=script&lang=js"
export * from "./AddressInfoSection.vue?vue&type=script&lang=js"

import "./AddressInfoSection.vue?vue&type=style&index=0&id=908acf2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-908acf2e"]])

export default __exports__